
import React, { useState, useMemo, useEffect } from "react";
import Pagination from "../../components/pagination/pagination";
import MoreIcon from '../../assets/DashBoard/more-icon.svg'
import userdetailsEllipse from "../../assets/UserProfile/userdetailsEllipse.svg"
let PageSize = 120000;

const TransactionTableView = ({
    data,
    isdatachage,
    clearChange,
    selectedDetails,
    onModify,
    onCancel
}) => {
console.log(data)

    const [currentPage, setCurrentPage] = useState(1);
    // const currentTableData = useMemo(() => {
    //     if (isdatachage === true) {
    //         setCurrentPage(1);
    //     }

    //     var cstep = data.length > PageSize ? currentPage : 1;
    //     const firstPageIndex = (cstep - 1) * PageSize;
    //     const lastPageIndex = firstPageIndex + PageSize;
    //     return data.slice(firstPageIndex, lastPageIndex);
    // }, [currentPage, data]);
    const currentTableData = data || []

    const nextPage = (page) => {
        clearChange();
        setCurrentPage(page);
    };

    const viewSummary =(that) =>{
        console.log(that)
        selectedDetails(that)
    }
    return (
        <div className="col-lg-12 col-md-12 col-12">
            <div className="table-responsive hideformob tableDiv traIPOparentable">
                <table className="table customTable IPOTable">

                    <thead>
                        <tr>
                            <th>IPO Name</th>
                            <th>Start Date</th>
                            <th>Closed Date</th>
                            <th className="text-start">No of bids</th>
                            <th className="text-start">Actions</th>
                            {/* <th className="text-start">Amount</th>
                            <th className="text-start">Allotment Status</th>
                            <th className="text-start">View</th> */}

                        </tr>
                    </thead>
                    <tbody>
                        {
                            currentTableData.map((i, index) => {
                                const disable_modify = false // i.can_modify == 'N'
                                const disable_cancel =  i.can_cancel == 'N'

                                return <tr key={index}>
                                    <td className="text-start"><p className="ipoName">{i.name}</p><a className="ipoNameorder">Application ID {i.appl_no}</a></td>
                                    <td className="text-start  text-startTd">{i.BiddingStartDate}</td>
                                    <td className="text-start  text-startTd">{i.BiddingEndDate}</td>
                                    <td className="text-start">{i.no_bids}</td>
                                    <td className="text-start text-startTd ">
                                            <button
                                                onClick={()=>onModify?.(i)}
                                                className={` p-2 px-3 rounded me-3 ipo-list-modify ${disable_modify?'opacity-50':''}`}
                                                disabled={disable_modify}
                                            >
                                                Modify
                                            </button>
                                            <button
                                                onClick={()=>onCancel?.(i)}
                                                className={`  p-2 px-3 rounded ipo-list-cancel ${disable_cancel?'opacity-50':''}`}
                                                disabled={disable_cancel}
                                            >
                                                Cancel
                                            </button>
                                    </td>
                                    
                                    {/* <td className="text-start text-startTd">{i.quantity}</td> */}
                                    {/* <td className="text-start text-startTd">{i.amount}</td> */}
                                    {/* <td className="text-start text-startTd"> <span className="badge rounded-pill  customAllocate">{i.allotment_status}</span></td> */}
                                    {/* <td className="text-start text-startTd ">
                                        <div className="viewSummaryParent">
                                            <img
                                                src={MoreIcon}
                                                className="showSummary"
                                            />
                                            <div className="viewSummaryBoc">
                                                <p onClick={()=>viewSummary(i)}>View Summary</p>
                                            </div>
                                        </div>

                                    </td>
                                */}
                                </tr> 
                            })
                        }
                    </tbody>

       

                </table>
                {currentTableData.length === 0 && (
                        <div className="norecords text-center w-100">
                            <p>No Records Found</p>
                        </div>
                    )}
            </div>
            <div className="showMob">


                <div className="row ">

                    {
                        currentTableData.map((i, index) => (
                            <div className="col-lg-12 col-md-12 col-12" key={index}>
                                <div className="mobile_ParentCard">
                                    <div className="mobile_headerName ">
                                        <div className="commonFlexwithspacearound">
                                            <div className="headerInner">
                                                <p className="ipoNameMobile">IPO: <span>{i.ipo_name}</span> </p>
                                                <span><a className="ipoNameorderMobile">Application ID {i.appl_no}</a></span>

                                            </div>


                                            <div className="viewSummaryParentMobile ">
                                                <img
                                                    src={userdetailsEllipse}
                                                    className="showSummary"
                                                />
                                                <div className="viewSummaryBoc">
                                                    <p onClick={()=>viewSummary(i)}>View Summary</p>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="borderBottom p15">
                                        <div className="commonFlexwithspacearound">
                                            <p className="ipoDetailsMobile_label">Closed Date</p>
                                            <p className="ipoDetailsMobile_value">{i.close_date}</p>
                                        </div>
                                    </div>

                                    <div className="borderBottom p15">
                                        <div className="commonFlexwithspacearound">
                                            <p className="ipoDetailsMobile_label">Quantity</p>
                                            <p className="ipoDetailsMobile_value">{i.quantity}</p>
                                        </div>
                                    </div>

                                    <div className="borderBottom p15">
                                        <div className="commonFlexwithspacearound">

                                            <p className="ipoDetailsMobile_label">Amount</p>
                                            <p className="ipoDetailsMobile_value">{i.amount}</p>
                                        </div>
                                    </div>

                                    <div className=" p15">
                                        <div className="commonFlexwithspacearound">

                                            <p className="ipoDetailsMobile_label">Allotment Status</p>
                                            <p className="ipoDetailsMobile_value"> <span className="badge rounded-pill p-2 customAllocate">{i.allotment_status}</span></p>
                                        </div>
                                    </div>




                                </div>
                            </div>

                        ))
                    }
                </div>
            </div>
            <div className="displyfle mobilemargin">
                <Pagination className="pagination-bar "
                    onPageChange={(page) => nextPage(page)}
                    currentPage={currentPage}
                    totalCount={data.length}
                    pageSize={PageSize}
                />
                {/* <Pagination
className="pagination-bar justify-content-center"
currentPage={currentPage}
totalCount={data.length}
pageSize={PageSize}
onPageChange={(page) => nextPage(page)}
/> */}
            </div>
        </div>
    )
}

export default TransactionTableView;